export default __webpack_public_path__ + "static/media/image-6.75cfeb94.webp";